import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useBankTransactionStore = defineStore('bankTransaction', {
  state: () => ({
    bankTransactions: {},
    unsubs: [],
  }),
  persist: { paths: ['bankTransactions'] },
  getters: {
    allBankTransactions(state) {
      return Object.values(state.bankTransactions).sort((a, b) => {
        const dateDiff = (Number(b.date) || 0) - (Number(a.date) || 0);
        if (dateDiff !== 0) return dateDiff;
        return (b.createdAt || 0) - (a.createdAt || 0);
      });
    },
    transactionsByAccount: (state) => (accountId) =>
      Object.values(state.bankTransactions)
        .filter((tx) => tx.accountId === accountId)
        .sort((a, b) => (Number(b.date) || 0) - (Number(a.date) || 0)),
    transactionCountByAccount: (state) => (accountId) =>
      Object.values(state.bankTransactions).filter((tx) => tx.accountId === accountId).length,
  },
  actions: {
    upsert({ id, value }) {
      this.bankTransactions = { ...this.bankTransactions, [id]: value };
    },
    remove(id) {
      const bankTransactions = { ...this.bankTransactions };
      delete bankTransactions[id];
      this.bankTransactions = bankTransactions;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.bankTransactions = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      const snapshotQuery = collection(firestore, 'bankTransactions');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('BankTransaction - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    },
  },
});
